import { render, staticRenderFns } from "./FaqSectionCreate.vue?vue&type=template&id=70c89bac&scoped=true&"
import script from "./FaqSectionCreate.vue?vue&type=script&lang=js&"
export * from "./FaqSectionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c89bac",
  null
  
)

export default component.exports